import { render, staticRenderFns } from "./ContasLamfa.vue?vue&type=template&id=078277ba&"
import script from "./ContasLamfa.vue?vue&type=script&lang=js&"
export * from "./ContasLamfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports